/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { IFormModelFactory } from "./FormModel/IFormModelFactory";
import { IFormModelDescriptor } from "./FormModel/FormModel";

/**
 * Form not found error
 */
export class FormNotFoundError extends Error {}

/**
 * Container for registered forms
 */
export class FormRepository {

	/** Registered forms */
	private forms: { [K: string]: IFormModelFactory } = {};

	/** List of form descriptor */
	private formList: Array<IFormModelDescriptor> = [];

	/**
	 * Register a form
	 *
	 * @param factory Form factory
	 */
	public register(factory: IFormModelFactory) {

		const formProto = factory();
		const config = formProto.getConfig();

		const key = config.id + "_" + config.version;

		this.forms[key] = factory;

		this.formList.push({
			id: config.id,
			version: config.version,
			title: config.title,
			icon: config.icon,
			showInMenu: config.showInMenu
		});

	}

	/**
	 * Materializes a form
	 *
	 * @param formId Form ID
	 * @param formVersion Form version
	 */
	public materialize(formId: string, formVersion: string) {

		const key = formId + "_" + formVersion;

		if (!this.forms[key]) {
			throw new FormNotFoundError(`Form '${key}' not found.`);
		}

		return this.forms[key]();

	}

	/**
	 * Returns a list of registered form descriptors
	 */
	public getList() {

		return this.formList;

	}

}
